import BasePayload from "../base-payload.ts";

export default class BaseOutgoingPayload extends BasePayload {
  constructor(event: string) {
    super(event, crypto.randomUUID());
  }
}
